module.exports = __webpack_public_path__ + "img/c936f82.jpeg";